"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _input = _interopRequireDefault(require("./input"));

var _Button = require("../Button");

var _parts = require("./parts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = function _default(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value,
      id = _ref.id,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      autoFocus = _ref.autoFocus,
      large = _ref.large,
      small = _ref.small,
      props = _objectWithoutProperties(_ref, ["value", "id", "onChange", "disabled", "autoFocus", "large", "small"]);

  var _React$useState = _react["default"].useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      key = _React$useState2[0],
      setKey = _React$useState2[1],
      _React$useState3 = _react["default"].useState(""),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      keyValue = _React$useState4[0],
      setKeyValue = _React$useState4[1];

  var node = null;

  var addToObject = function addToObject() {
    onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, keyValue)));
    setKey("");
    setKeyValue("");
    node && node.focus();
  };

  var onKeyDown = function onKeyDown(e) {
    if (key && keyValue && e.keyCode === 13) {
      e.stopPropagation();
      e.preventDefault();
      addToObject();
    }
  };

  var _remove = function remove(k) {
    delete value[k];
    onChange(_objectSpread({}, value));
  };

  var _edit = function edit(k) {
    setKey(k);
    setKeyValue(value[k]);

    _remove(k);

    node && node.focus();
  };

  var numKeys = Object.keys(value).length;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    className: "flex-1",
    value: key,
    onChange: setKey,
    id: id,
    autoFocus: autoFocus,
    ref: function ref(n) {
      return node = n;
    },
    disabled: disabled,
    onKeyDown: onKeyDown,
    large: large,
    small: small
  }), /*#__PURE__*/_react["default"].createElement(_input["default"], {
    className: "flex-1 ml-1",
    value: keyValue,
    onKeyDown: onKeyDown,
    onChange: setKeyValue,
    disabled: disabled,
    large: large,
    small: small
  }), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "flex-0 ml-1",
    onClick: addToObject,
    disabled: disabled || !key || !keyValue || key in value,
    large: large,
    small: small
  }, "Add to Object")), !numKeys ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-1 ml-10"
  }, /*#__PURE__*/_react["default"].createElement(_parts.ValueContainer, {
    className: "cursor-default"
  }, /*#__PURE__*/_react["default"].createElement(_parts.ValueItem, null, "{"), Object.keys(value).map(function (k, i) {
    return /*#__PURE__*/_react["default"].createElement(_parts.ValueItem, {
      key: k,
      edit: function edit(e) {
        return _edit(k);
      },
      remove: function remove(e) {
        return _remove(k);
      }
    }, k, ": ", value[k]);
  }), /*#__PURE__*/_react["default"].createElement(_parts.ValueItem, null, "}"))));
};

exports["default"] = _default;